<div class="flex flex-wrap justify-end gap-4 filters-wrapper">
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="insiderName"
    type="text"
    placeholder="Search by insider name"
    class="border-b-1 border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'insiderName')"
  />
  <input
    (keydown.enter)="onSearch()"
    [(ngModel)]="issuerName"
    type="text"
    placeholder="Search by issuer name"
    class="border-b-1 border-gray-400 focus:outline-none focus:border-[#001529] px-1 py-1 placeholder-gray-400"
    (keydown)="preventSpaceKey($event)"
    (paste)="onPaste($event, 'issuerName')"
  />
</div>

<div class="mb-4"></div>
<div>
  <p-table
    [value]="insiders"
    [paginator]="insiders.length > 0"
    [rows]="paginator.pageSize"
    (onLazyLoad)="loadData($event)"
    [lazy]="true"
    [totalRecords]="paginator.totalCount"
    [loading]="isLoading"
    [(selection)]="selectedInsiders"
    dataKey="arcId"
    [showCurrentPageReport]="true"
    [tableStyle]="{ 'min-width': '50rem' }"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onPage)="onInsiderPageChange($event)"
    [rowsPerPageOptions]="[10, 25, 50]"
  >
    <ng-template #header>
      <tr>
        <th>Id</th>
        <th>Insider Name</th>
        <th>CIK</th>
        <th>P2iq</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #body let-insider>
      <tr>
        <td>{{ insider.insiderId || "N/A" }}</td>
        <td>{{ insider.insiderName || "N/A" }}</td>
        <td>{{ insider.insiderCik || "N/A" }}</td>
        <td>{{ insider.p2iq || "N/A" }}</td>

        <td class="space-x-2">
          <button
            class="hover:bg-[#1f273b] hover:text-white cursor-pointer text-gray-800 py-1 px-3 border border-gray-400 rounded"
            (click)="onUpdateClick(insider)"
          >
            Update
          </button>
          <button
            class="hover:bg-[#1f273b] hover:text-white bg-white cursor-pointer text-gray-800 py-1 px-3 border border-gray-400 rounded"
            (click)="onDetailClick(insider)"
          >
            Detail
          </button>
          <button
            *ngIf="insider.isDeleteAble"
            (click)="onDeleteClick(insider)"
            class="hover:bg-[#1f273b] hover:text-white bg-white cursor-pointer text-gray-800 py-1 px-3 border border-gray-400 rounded"
          >
            Delete
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #noData>
  <div class="text-center py-6 text-gray-500">No record found.</div>
</ng-template>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
